
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/i-vini/[...title]",
      function () {
        return require("private-next-pages/i-vini/[...title].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/i-vini/[...title]"])
      });
    }
  